export default {
  calculateCalculatedDiscPcnt(salesUMStandardPrice, salesUMPrice) {
    return salesUMStandardPrice === 0
      ? 0
      : (100.0 - (100.0 * salesUMPrice) / salesUMStandardPrice).roundNumber(2);
  },

  calculateDiscPcnt(salesUMPrice, salesUMNetPrice) {
    return salesUMPrice == 0
      ? 0
      : ((salesUMPrice - salesUMNetPrice) / salesUMPrice) * 100;
  },

  calculateGrossProfitPcnt(salesUMStandardCost, salesUMNetPrice) {
    if (salesUMNetPrice === 0) {
      return 0;
    }

    return (
      ((salesUMNetPrice - salesUMStandardCost) / salesUMNetPrice) *
      100
    ).roundNumber(2);
  },
  // Unrounded GP% — use for minimum-margin threshold comparisons so a raw
  // value just under the floor (e.g. 14.9981%) can't round up and pass.
  calculateGrossProfitPcntRaw(salesUMStandardCost, salesUMNetPrice) {
    if (salesUMNetPrice === 0) {
      return 0;
    }

    return (
      ((salesUMNetPrice - salesUMStandardCost) / salesUMNetPrice) *
      100
    );
  },
  calculateMarkup(salesUMStandardCost, salesUMNetPrice) {
    if (salesUMStandardCost === 0) {
      return 0;
    }

    return (
      ((salesUMNetPrice - salesUMStandardCost) / salesUMStandardCost) *
      100
    ).roundNumber(2);
  },

  calculatePriceLandedUnitCost(salesUMFXPrice, discountPcnt, wetPcnt) {
    return (
      salesUMFXPrice *
      (1 - discountPcnt / 100.0) *
      (1 + wetPcnt / 100.0)
    ).roundNumber(4);
  },
  calculateSalesUMFXPrice(salesUMPrice, exchangeRate) {
    return (salesUMPrice * exchangeRate).roundNumber(4);
  },
  calculateSalesUMNetFXPrice(salesUMFXPrice, discPcnt) {
    return (salesUMFXPrice - salesUMFXPrice * (discPcnt / 100)).roundNumber(4);
  },
  calculateSalesUMNetPrice(salesUMPrice, discPcnt) {
    return (salesUMPrice - salesUMPrice * (discPcnt / 100)).roundNumber(4);
  },
  calculateSalesUMPriceFromSalesUMFXPrice(salesUMFXPrice, exchangeRate) {
    return (
      exchangeRate == 0 ? salesUMFXPrice : salesUMFXPrice / exchangeRate
    ).roundNumber(4);
  },
  calculateSalesUMNetPriceFromSalesUMNetFXPrice(
    salesUMNetFXPrice,
    exchangeRate
  ) {
    return (
      exchangeRate == 0 ? salesUMNetFXPrice : salesUMNetFXPrice / exchangeRate
    ).roundNumber(4);
  },
  calculateSalesUMFXPriceFromSalesUMNetFXPrice(salesUMNetFXPrice, discPcnt) {
    if (discPcnt == 100) return 0;

    return ((salesUMNetFXPrice * 100) / (100 - discPcnt)).roundNumber(4);
  },
  calculateSalesUMNetFXPriceFromSalesUMFXPrice(salesUMFXPrice, discPcnt) {
    return ((salesUMFXPrice * (100 - discPcnt)) / 100).roundNumber(4);
  },
  calculateSalesUMPriceForGP(
    salesUMStandardPrice,
    salesUMStandardCost,
    grossProfitPercent
  ) {
    if (typeof grossProfitPercent === "string")
      grossProfitPercent = Number(grossProfitPercent);

    if (grossProfitPercent == 100) return salesUMStandardCost;

    return (
      (salesUMStandardCost * 100) /
      (100 - grossProfitPercent.roundNumber(2))
    ).roundNumber(4);

    // SP = C + (grossProfitPercent / 100)SP
    // SP(1 - grossProfitPercent / 100) = C
    // SP = 100C /  (100 - grossProfitPercent)
  },
  calculateSalesUMQty(stockUMQty, salesUMConversion) {
    return stockUMQty / salesUMConversion;
  },
  calculateSalesUMStandardPrice(stockUMStandardPrice, salesUMConversion) {
    return salesUMConversion === 0
      ? stockUMStandardPrice
      : (stockUMStandardPrice / salesUMConversion).roundNumber(4);
  },
  calculateStockUMFXPrice(salesUMFXPrice, salesUMConversion) {
    return salesUMConversion === 0
      ? salesUMFXPrice
      : (salesUMFXPrice / salesUMConversion).roundNumber(4);
  },
  calculateStockUMNetFXPrice(salesUMNetFXPrice, salesUMConversion) {
    return salesUMConversion === 0
      ? salesUMNetFXPrice
      : (salesUMNetFXPrice / salesUMConversion).roundNumber(4);
  },
  calculateStockUMNetPrice(salesUMNetPrice, salesUMConversion) {
    return salesUMConversion === 0
      ? salesUMNetPrice
      : (salesUMNetPrice / salesUMConversion).roundNumber(4);
  },
  calculateStockUMPrice(salesUMPrice, salesUMConversion) {
    return salesUMConversion === 0
      ? salesUMPrice
      : (salesUMPrice / salesUMConversion).roundNumber(4);
  },
  calculateStockUMQty(salesUMQty, salesUMConversion) {
    return salesUMQty * (salesUMConversion === 0 ? 1 : salesUMConversion);
  },
  calculateStockUMStandardPrice(salesUMStandardPrice, salesUMConversion) {
    return salesUMConversion === 0
      ? salesUMStandardPrice
      : (salesUMStandardPrice * salesUMConversion).roundNumber(4);
  },
  calculateDiscFXLineTotal(salesUMFXPrice, salesUMNetFXPrice, salesUMQty) {
    return ((salesUMFXPrice - salesUMNetFXPrice) * salesUMQty).roundNumber(2);
  },
  // calculateNetFXLineTotal(salesUMNetFXPrice, salesUMQty) {
  //   return (salesUMNetFXPrice * salesUMQty).roundNumber(2);
  // },
  
  // Net Fx Line Total = (Sales UM FX Price * Sales UM Qty) - ((Sales UM FX Price - Sales UM Net FX Price) * Sales UM Qty)
  // Ref From BackEnd Calculation to avoid rounding issues
  // "@NetFXLineTotal"       = ROUND((ROUND(d.SalesUMFXPrice * d.SalesUMQty, 2) - ROUND((d.SalesUMFXPrice - (d.SalesUMNetFXPrice)) * d.SalesUMQty, 2)) , 2),           
  calculateNetFXLineTotal(SalesUMNetFXPrice, SalesUMQty, SalesUMFXPrice) {
    const round = (value) =>
      Math.round((value + Number.EPSILON) * 100) / 100;

    return round(
      round(SalesUMFXPrice * SalesUMQty) -
      round((SalesUMFXPrice - SalesUMNetFXPrice) * SalesUMQty)
    );
  },
  calculateWetFXLineTotal(netFXLineTotal, wetPcnt) {
    return (netFXLineTotal * (wetPcnt / 100.0)).roundNumber(2);
  },

  calculateTaxableFXLineTotal(netFXLineTotal, wetFXLineTotal) {
    let total = (netFXLineTotal * 1000 + wetFXLineTotal * 1000) / 1000;

    return total.roundNumber(2); // weird javascript rounding issue, use 1000
  },
  calculateTaxFXLineTotal(netFXLineTotal, wetFXLineTotal, salesTaxPcnt) {
    let total = (netFXLineTotal * 1000 + wetFXLineTotal * 1000) / 1000;

    return ((total * salesTaxPcnt) / 100).roundNumber(2); // weird javascript rounding issue, use 1000
  },
  calculateFXLineTotal(taxableFXLineTotal, taxFXLineTotal) {
    let total = (taxableFXLineTotal * 1000 + taxFXLineTotal * 1000) / 1000;

    return total.roundNumber(2); // weird javascript rounding issue, use 1000
  },

  calculateDiscLineTotal(discFXLineTotal, exchangeRate) {
    return (
      exchangeRate == 0 ? discFXLineTotal : discFXLineTotal / exchangeRate
    ).roundNumber(2);
  },
  calculateNetLineTotal(netFXLineTotal, exchangeRate) {
    return (
      exchangeRate == 0 ? netFXLineTotal : netFXLineTotal / exchangeRate
    ).roundNumber(2);
  },
  calculateWetLineTotal(wetFXLineTotal, exchangeRate) {
    return (
      exchangeRate == 0 ? wetFXLineTotal : wetFXLineTotal / exchangeRate
    ).roundNumber(2);
  },

  calculateTaxableLineTotal(taxableFXLineTotal, exchangeRate) {
    return (
      exchangeRate == 0 ? taxableFXLineTotal : taxableFXLineTotal / exchangeRate
    ).roundNumber(2);
  },
  calculateTaxLineTotal(taxFXLineTotal, exchangeRate) {
    return (
      exchangeRate == 0 ? taxFXLineTotal : taxFXLineTotal / exchangeRate
    ).roundNumber(2);
  },
  calculateLineTotal(fxLineTotal, exchangeRate) {
    return (
      exchangeRate == 0 ? fxLineTotal : fxLineTotal / exchangeRate
    ).roundNumber(2);
  },
};

export const FxToBaseCurrency = (fxAmount, exchangeRate) => {
  return (fxAmount.roundNumber(2) / exchangeRate).roundNumber(2);
};

export const CalculateRounding = (total) => {
  let roundingValue = 0;
  let value = Math.abs((total * 100) % 5);

  switch (Math.round(value).toString()) {
    case "1":
      roundingValue = -0.01;
      break;
    case "2":
      roundingValue = -0.02;
      break;
    case "3":
      roundingValue = 0.02;
      break;
    case "4":
      roundingValue = 0.01;
      break;
    case "6":
      roundingValue = -0.01;
      break;
    case "7":
      roundingValue = -0.02;
      break;
    case "8":
      roundingValue = 0.02;
      break;
    case "9":
      roundingValue = 0.01;
      break;
    default:
      roundingValue = 0;
      break;
  }

  return roundingValue;
};
